module.exports = __webpack_public_path__ + "img/img2.ddd0e625.png";